import React from 'react';

interface CustomRenderProps {
  component: any;
  componentProps?: any;
}

export const CustomRender = ({ component: Comp, componentProps = {} }: CustomRenderProps) => <Comp {...componentProps} />;
